
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import user_mixin from "~/mixins/user_mixin";

export default {
  head() {
    return {
      title: "Get in Touch with Us | Contact information for BrainGymJr",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Have questions or concerns? We're here to help! Contact us today via phone, email, or by filling out our easy-to-use online form. BrainGymJr  is dedicated to providing excellent customer service and support."
        }
      ]
    };
  },
  layout(context) {
    return context.$auth.loggedIn ? "parents" : "home";
  },
  mixins: [user_mixin],
  watch: {
    successDialog(newVal, oldVal) {
      //console.log("new", newVal, oldVal);
      if (newVal === false && oldVal === true) {
        this.$router.replace("/");
      }
    }
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      subjects: [],
      phone: null,
      email: null,
      query: null,
      subject: null,
      user_id: this.$auth.user ? this.$auth.user.id : null,
      user_profile_id: 0,

      subject_id: 0,
      subject_name: null,
      submitted: false,
      valid: false,
      snackbarText: null,
      successDialog: false,
      userSubjectLevel: [],
      snackbar: false,
      snackbarColor: "info",
      snackbarText: "User already exist"
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    phone: { required },
    email: { required, email },
    query: { required, minLength: minLength(5) }
  },
  async mounted() {
    this.subjects = await this.$api.subjects.find({ $paginate: false });
    this.firstName = this.$auth.user ? this.getFirstName : null;
    this.lastName = this.$auth.user ? this.getLastName : null;
    this.email = this.$auth.user ? this.$auth.user.email : null;
    this.phone = this.$auth.user ? this.$auth.user.phone_number : null;
    this.user_profile_id = this.getChild.id;
  },
  computed: {
    nameErrors() {
      if (this.submitted) {
        const errors = [];
        if (!this.$v.firstName.$dirty) return errors;
        if (!this.$v.lastName.$dirty) return errors;
        !this.$v.firstName.required && errors.push("First name is required");
        !this.$v.lastName.required && errors.push("Last name is required");
        return errors;
      }
    },
    phoneErrors() {
      if (this.submitted) {
        const errors = [];
        if (!this.$v.phone.$dirty) return errors;
        !this.$v.phone.required && errors.push("Phone number is required");
        return errors;
      }
    },
    emailErrors() {
      if (this.submitted) {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.email && errors.push("Must be valid e-mail");
        !this.$v.email.required && errors.push("E-mail is required");
        return errors;
      }
    },
    queryErrors() {
      if (this.submitted) {
        const errors = [];
        if (!this.$v.query.$dirty) return errors;
        !this.$v.query.required && errors.push("Query required");
        !this.$v.query.minLength &&
          errors.push("Query Minimum length is 5 characters");
        return errors;
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async onSubmit() {
      this.submitted = true;
      // stop here if f0orm is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        //console.log("inside onSubmit", this.$v);
        this.snackbarText =
          "You have missed some fields. Kindly enter your details to proceed";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }
      if (this.validate()) {
        //console.log("Validate: " + this.validate());
      }
      const dataToSubmit = {
        first_name: this.firstName,
        last_name: this.lastName,
        phone: this.phone,
        email: this.email,
        query: this.query,
        subject: "No Subject",
        user_id: 0,
        user_profile_id: 0,
        current_level: 0,
        subject_id: 0
      };
      try {
        const rsp = await this.$api.userRequest.create(dataToSubmit);
        this.successDialog = true;
      } catch (error) {
        //this.snackbarText = error.response.data.message;
        //this.snackbar = true;
        console.error("error", error);
      }
    },
    goToJumpRequest() {
      this.$router.replace("/parents/jump-request");
    }
  }
};
